var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9613 6.2789C28.961 6.27927 28.9617 6.27853 28.9613 6.2789L22.9376 12.3248L20.6465 10.0421L26.6744 3.99195C29.2304 1.43595 32.6971 0 36.3118 0C39.9265 0 43.3932 1.43595 45.9492 3.99195C48.5052 6.54795 49.9412 10.0146 49.9412 13.6294C49.9412 17.2441 48.5052 20.7108 45.9492 23.2668L45.9471 23.2689L39.8991 29.2947L37.6163 27.0035L43.6623 20.9798C43.6627 20.9794 43.6631 20.979 43.6635 20.9786C45.6122 19.0293 46.7069 16.3857 46.7069 13.6294C46.7069 10.8724 45.6117 8.22836 43.6623 6.2789C41.7128 4.32944 39.0688 3.23424 36.3118 3.23424C33.5554 3.23424 30.9107 4.33014 28.9613 6.2789Z",
    fill: "#53D0A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0421 20.6465L12.3248 22.9376L6.2789 28.9613C6.27853 28.9617 6.27927 28.961 6.2789 28.9613C4.33014 30.9107 3.23424 33.5554 3.23424 36.3118C3.23424 39.0688 4.32944 41.7128 6.2789 43.6623C8.22836 45.6117 10.8724 46.7069 13.6294 46.7069C16.3857 46.7069 19.0293 45.6122 20.9786 43.6635C20.979 43.6631 20.9794 43.6627 20.9798 43.6623L27.0035 37.6163L29.2947 39.8991L23.2689 45.9471L23.2668 45.9492C20.7108 48.5052 17.2441 49.9412 13.6294 49.9412C10.0146 49.9412 6.54795 48.5052 3.99195 45.9492C1.43595 43.3932 0 39.9265 0 36.3118C0 32.6971 1.43595 29.2304 3.99195 26.6744L10.0421 20.6465Z",
    fill: "#53D0A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2207 34.4333L34.4333 13.2207L36.7203 15.5077L15.5077 36.7203L13.2207 34.4333Z",
    fill: "#53D0A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.72705ff038c9f206d33faf8b6a1215b3.svg";
export { ForwardRef as ReactComponent };